
import NotificationFavorite from "../../../assets/outline/NotificationFavorite.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function NotificationFavoriteIcon({ className, dataTestid = "NotificationFavoriteIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <NotificationFavorite data-testid={dataTestid} className={classes} {...rest} />
  );
}
